import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, ArrowRight, Phone } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";
import Logo from "./Logo";
import { contact } from "../mock";

const links = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "SafeRide", to: "/saferide" },
  { label: "Luxury Add-Ons", to: "/luxury-add-ons" },
  { label: "FAQs", to: "/faqs" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#0c1620]/95 backdrop-blur-md border-b border-white/5 py-2.5 shadow-[0_10px_30px_-15px_rgba(0,0,0,0.9)]"
          : "bg-gradient-to-b from-[#0c1620]/90 to-transparent py-4"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 flex items-center justify-between">
        <Logo />

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => {
            const active = location.pathname === l.to;
            return (
              <Link
                key={l.to}
                to={l.to}
                className={`relative text-sm font-medium tracking-wide transition-colors duration-300 ${
                  active ? "text-[var(--gold)]" : "text-gray-200 hover:text-[var(--gold)]"
                }`}
              >
                {l.label}
                <span
                  className={`absolute -bottom-1.5 left-0 h-[2px] bg-[var(--gold)] transition-all duration-300 ${
                    active ? "w-full" : "w-0"
                  }`}
                />
              </Link>
            );
          })}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={`tel:${contact.phoneRaw}`}
            className="hidden xl:flex items-center gap-2 text-sm text-gray-300 hover:text-[var(--gold)] transition-colors"
          >
            <Phone size={15} /> {contact.phone}
          </a>
          <button
            onClick={() => navigate("/book")}
            className="btn-gold hidden sm:inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-xs font-semibold uppercase tracking-widest"
          >
            Book Now <ArrowRight size={15} />
          </button>

          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button className="lg:hidden text-[var(--gold)] p-2" aria-label="Menu">
                <Menu size={26} />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-[#0c1620] border-l border-white/10 w-[82%] sm:w-80">
              <div className="mt-4 mb-8">
                <Logo />
              </div>
              <nav className="flex flex-col gap-1">
                {links.map((l) => (
                  <Link
                    key={l.to}
                    to={l.to}
                    onClick={() => setOpen(false)}
                    className={`py-3 px-3 rounded-lg text-base font-medium transition-colors ${
                      location.pathname === l.to
                        ? "bg-white/5 text-[var(--gold)]"
                        : "text-gray-200 hover:bg-white/5 hover:text-[var(--gold)]"
                    }`}
                  >
                    {l.label}
                  </Link>
                ))}
                <button
                  onClick={() => {
                    setOpen(false);
                    navigate("/book");
                  }}
                  className="btn-gold mt-5 rounded-full px-5 py-3 text-sm font-semibold uppercase tracking-widest"
                >
                  Book Now
                </button>
                <a
                  href={`tel:${contact.phoneRaw}`}
                  className="mt-3 flex items-center justify-center gap-2 text-sm text-gray-300"
                >
                  <Phone size={15} /> {contact.phone}
                </a>
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
